module.exports = __webpack_public_path__ + "static/media/2.41b67e96.jpg";